import React from "react";
import moment from "moment";

const SimpleTemplate = ({ packageData, user }) => {
  if (!packageData?.package) return <div>Loading package data...</div>;
  const { package: pkg } = packageData;

  return (
    <div
      style={{
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
        color: "#1F2937",
        lineHeight: 1.7,
        maxWidth: "700px",
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#F3F4F6",
          padding: "40px 30px",
          borderRadius: "16px",
          marginBottom: "40px",
          textAlign: "center",
        }}
      >
        {user?.logo && (
          <img
            src={user.logo}
            alt="Company Logo"
            style={{
              height: "50px",
              marginBottom: "20px",
              backgroundColor: "#FFFFFF",
              padding: "10px",
              borderRadius: "8px",
            }}
          />
        )}
        <h1
          style={{
            fontSize: "2.25rem",
            fontWeight: 700,
            margin: "0 0 8px 0",
            color: "#1F2937",
          }}
        >
          {pkg.packageName}
        </h1>
        <p
          style={{
            fontSize: "1.125rem",
            margin: 0,
            color: "#6B7280",
          }}
        >
          {pkg.destinationsCover}
        </p>
        <div
          style={{
            marginTop: "20px",
            fontSize: "0.875rem",
            color: "#6B7280",
          }}
        >
          <p style={{ margin: "0 0 4px 0" }}>{pkg.contactName}</p>
          <p style={{ margin: "0 0 4px 0" }}>{pkg.contactEmail}</p>
          <p style={{ margin: 0 }}>{pkg.contactPhoneNumber}</p>
        </div>
      </header>

      {/* Package Image */}
      {pkg.imageSrc && (
        <div
          style={{
            marginBottom: "40px",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
          }}
        >
          <img
            src={pkg.imageSrc}
            alt={pkg.packageName}
            style={{
              width: "100%",
              height: "300px",
              objectFit: "cover",
            }}
            onError={(e) => (e.target.style.display = "none")}
          />
        </div>
      )}

      {/* Summary */}
      <section
        style={{
          backgroundColor: "#F9FAFB",
          padding: "30px",
          borderRadius: "12px",
          marginBottom: "40px",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: 600,
            margin: "0 0 24px 0",
            color: "#1F2937",
          }}
        >
          Package Summary
        </h2>
        <dl style={{ margin: 0, display: "grid", gap: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "#3B82F6",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "1rem",
              }}
            >
              ⏱
            </span>
            <div>
              <dt style={{ fontWeight: 600, margin: 0 }}>Duration</dt>
              <dd style={{ margin: 0, color: "#6B7280" }}>{pkg.duration}</dd>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "#3B82F6",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "1rem",
              }}
            >
              📅
            </span>
            <div>
              <dt style={{ fontWeight: 600, margin: 0 }}>Start Date</dt>
              <dd style={{ margin: 0, color: "#6B7280" }}>
                {moment(pkg.startedDate).format("MMMM Do, YYYY")}
              </dd>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "#3B82F6",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "1rem",
              }}
            >
              📍
            </span>
            <div>
              <dt style={{ fontWeight: 600, margin: 0 }}>Destinations</dt>
              <dd style={{ margin: 0, color: "#6B7280" }}>{pkg.destinationsCover}</dd>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "#3B82F6",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "1rem",
              }}
            >
              💰
            </span>
            <div>
              <dt style={{ fontWeight: 600, margin: 0 }}>Price</dt>
              <dd style={{ margin: 0, color: "#6B7280" }}>{pkg.price} {pkg.currency}</dd>
            </div>
          </div>
        </dl>
      </section>

      {/* Overview */}
      <section
        style={{
          marginBottom: "40px",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: 600,
            margin: "0 0 16px 0",
            color: "#1F2937",
            paddingLeft: "12px",
            borderLeft: "4px solid #3B82F6",
          }}
        >
          Overview
        </h2>
        <p
          style={{
            fontSize: "1rem",
            margin: 0,
            color: "#374151",
          }}
        >
          {pkg.description}
        </p>
      </section>

      {/* Itinerary */}
      {packageData.itineraries?.length > 0 && (
        <section
          style={{
            marginBottom: "40px",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: 600,
              margin: "0 0 24px 0",
              color: "#1F2937",
              paddingLeft: "12px",
              borderLeft: "4px solid #3B82F6",
            }}
          >
            Itinerary
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {packageData.itineraries
              .slice()
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((item, index) => (
                <article
                  key={index}
                  style={{
                    backgroundColor: "#F9FAFB",
                    padding: "24px",
                    borderRadius: "12px",
                    borderLeft: "4px solid #3B82F6",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: 600,
                      margin: "0 0 12px 0",
                      color: "#1F2937",
                    }}
                  >
                    {moment(item.date).format("MMMM Do, YYYY")} - {item.title}
                  </h3>
                  {item.location && (
                    <p
                      style={{
                        margin: "0 0 12px 0",
                        color: "#6B7280",
                      }}
                    >
                      <strong style={{ fontWeight: 600 }}>Location: </strong>
                      {item.location}
                    </p>
                  )}
                  <p
                    style={{
                      margin: "0 0 12px 0",
                      color: "#374151",
                    }}
                  >
                    {item.description}
                  </p>
                  {item.meals && (
                    <p
                      style={{
                        margin: "0 0 12px 0",
                        color: "#6B7280",
                      }}
                    >
                      <strong style={{ fontWeight: 600 }}>Meals: </strong>
                      {item.meals}
                    </p>
                  )}
                  {item.note && (
                    <p
                      style={{
                        margin: 0,
                        color: "#6B7280",
                      }}
                    >
                      <strong style={{ fontWeight: 600 }}>Note: </strong>
                      {item.note}
                    </p>
                  )}
                </article>
              ))}
          </div>
        </section>
      )}

      {/* Flight Details */}
      {packageData.flightBookings?.length > 0 && (
        <section
          style={{
            marginBottom: "40px",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: 600,
              margin: "0 0 24px 0",
              color: "#1F2937",
              paddingLeft: "12px",
              borderLeft: "4px solid #3B82F6",
            }}
          >
            Flight Details
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {packageData.flightBookings.map((flight, index) => (
              <article
                key={index}
                style={{
                  backgroundColor: "#F9FAFB",
                  padding: "20px",
                  borderRadius: "12px",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.125rem",
                    fontWeight: 600,
                    margin: "0 0 12px 0",
                    color: "#1F2937",
                  }}
                >
                  {flight.airline} - Flight {flight.flightNumber}
                </h3>
                <p
                  style={{
                    margin: "0 0 8px 0",
                    color: "#6B7280",
                  }}
                >
                  <strong style={{ fontWeight: 600 }}>Departure: </strong>
                  {flight.departureCity} at{" "}
                  {moment(flight.departureDateTime).format("MMM Do, YYYY h:mm a")}
                </p>
                <p
                  style={{
                    margin: "0 0 8px 0",
                    color: "#6B7280",
                  }}
                >
                  <strong style={{ fontWeight: 600 }}>Arrival: </strong>
                  {flight.arrivalCity} at{" "}
                  {moment(flight.arrivalDateTime).format("MMM Do, YYYY h:mm a")}
                </p>
                <p
                  style={{
                    margin: 0,
                    color: "#6B7280",
                  }}
                >
                  <strong style={{ fontWeight: 600 }}>Class: </strong>
                  {flight.cabinClass}
                </p>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* Hotel Bookings Table */}
      {packageData.hotelBookings?.length > 0 && (
        <section
          style={{
            marginBottom: "40px",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: 600,
              margin: "0 0 24px 0",
              color: "#1F2937",
              paddingLeft: "12px",
              borderLeft: "4px solid #3B82F6",
            }}
          >
            Hotel Bookings
          </h2>
          <div
            style={{
              overflowX: "auto",
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              backgroundColor: "#FFFFFF",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#F9FAFB",
                  }}
                >
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: 600,
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Hotel
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: 600,
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    City
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: 600,
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Check-In
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: 600,
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Check-Out
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: 600,
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Room Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {packageData.hotelBookings.map((hotel, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {hotel.hotelName}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {hotel.city}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {moment(hotel.checkInDate).format("MMM Do, YYYY")}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {moment(hotel.checkOutDate).format("MMM Do, YYYY")}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {hotel.roomType}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* Sightseeing Table */}
      {packageData.sightSeeings?.length > 0 && (
        <section
          style={{
            marginBottom: "40px",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: 600,
              margin: "0 0 24px 0",
              color: "#1F2937",
              paddingLeft: "12px",
              borderLeft: "4px solid #3B82F6",
            }}
          >
            Sightseeing
          </h2>
          <div
            style={{
              overflowX: "auto",
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              backgroundColor: "#FFFFFF",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#F9FAFB",
                  }}
                >
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Destination
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Attraction
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                {packageData.sightSeeings.map((sight, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {moment(sight.date).format("MMM Do, YYYY")}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {sight.destination}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {sight.sightseeingName}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {sight.description}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* Transfers Table */}
      {packageData.transfers?.length > 0 && (
        <section
          style={{
            marginBottom: "40px",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: 600,
              margin: "0 0 24px 0",
              color: "#1F2937",
              paddingLeft: "12px",
              borderLeft: "4px solid #3B82F6",
            }}
          >
            Transfers
          </h2>
          <div
            style={{
              overflowX: "auto",
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              backgroundColor: "#FFFFFF",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#F9FAFB",
                  }}
                >
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Pickup Time
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    From
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    To
                  </th>
                  <th
                    style={{
                      padding: "16px",
                      textAlign: "left",
                      fontWeight: "600",
                      color: "#1F2937",
                      borderBottom: "1px solid #E5E7EB",
                    }}
                  >
                    Vehicle
                  </th>
                </tr>
              </thead>
              <tbody>
                {packageData.transfers.map((transfer, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {moment(transfer.date).format("MMM Do, YYYY")}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {transfer.pickupTime}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {transfer.fromLocation}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {transfer.toLocation}
                    </td>
                    <td
                      style={{
                        padding: "16px",
                        borderBottom: "1px solid #E5E7EB",
                        color: "#374151",
                      }}
                    >
                      {transfer.vehicleDetails}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {/* Includes and Excludes */}
      {(packageData.includes?.length > 0 || packageData.excludes?.length > 0) && (
        <section
          style={{
            marginBottom: "40px",
            display: "grid",
            gap: "32px",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          }}
        >
          {packageData.includes?.length > 0 && (
            <div>
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  margin: "0 0 16px 0",
                  color: "#1F2937",
                  paddingLeft: "12px",
                  borderLeft: "4px solid #10B981",
                }}
              >
                Includes
              </h2>
              <ul
                style={{
                  listStyleType: "disc",
                  paddingLeft: "24px",
                  margin: 0,
                }}
              >
                {packageData.includes.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: "8px",
                      color: "#374151",
                    }}
                  >
                    {item.description}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {packageData.excludes?.length > 0 && (
            <div>
              <h2
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  margin: "0 0 16px 0",
                  color: "#1F2937",
                  paddingLeft: "12px",
                  borderLeft: "4px solid #EF4444",
                }}
              >
                Excludes
              </h2>
              <ul
                style={{
                  listStyleType: "disc",
                  paddingLeft: "24px",
                  margin: 0,
                }}
              >
                {packageData.excludes.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: "8px",
                      color: "#374151",
                    }}
                  >
                    {item.description}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </section>
      )}

      {/* Terms & Conditions */}
      {packageData.termsandConditions?.length > 0 && (
        <section
          style={{
            marginBottom: "40px",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: 600,
              margin: "0 0 24px 0",
              color: "#1F2937",
              paddingLeft: "12px",
              borderLeft: "4px solid #3B82F6",
            }}
          >
            Terms & Conditions
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {packageData.termsandConditions.map((term, index) => (
              <article key={index}>
                <h3
                  style={{
                    fontSize: "1.125rem",
                    fontWeight: 600,
                    margin: "0 0 8px 0",
                    color: "#1F2937",
                  }}
                >
                  {term.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    color: "#374151",
                  }}
                >
                  {term.description}
                </p>
              </article>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default SimpleTemplate;